
<header-row [userName]="'Victoria Brown'" [userRole]="'REGIONAL MANAGER'"></header-row>

<div class="csv-modal-container main-class-for-leader">
  <div class="modal-header">
    <div class="page-title">
    Upload Goals CSV Data
    </div>
    <!-- <button class="close-x" (click)="onCancel()">
      <mat-icon>close</mat-icon>
    </button> -->
  </div>

  <div class="modal-body">
    <div class="upload-dropzone" [class.file-ready]="selectedFile" [class.drag-over]="isDragOver"
      (click)="fileInput.click()" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)">
      <input type="file" #fileInput (change)="onFileSelected($event)" accept=".csv" style="display:none">
      
      <mat-icon class="upload-icon">{{ selectedFile ? 'insert_drive_file' : 'cloud_upload' }}</mat-icon>
      
      <div class="upload-instructions">
        <span class="primary-text" *ngIf="!selectedFile">Click to upload or drag and drop</span>
        <span class="primary-text" *ngIf="selectedFile">{{ selectedFile.name }}</span>
        <span class="secondary-text">CSV files only (Max 10MB)</span>
      </div>
    </div>

    <div class="file-preview-card" *ngIf="selectedFile"
         [class.is-uploading]="isUploading"
         [class.has-error]="!isUploading && uploadErrors.length > 0">
       <div class="file-meta">
         <ng-container *ngIf="isUploading">
           <mat-icon class="spin">autorenew</mat-icon>
           <span>Processing...</span>
         </ng-container>
         <ng-container *ngIf="!isUploading && uploadErrors.length > 0">
           <mat-icon class="error">error_outline</mat-icon>
           <span>Upload failed — see errors below</span>
         </ng-container>
         <ng-container *ngIf="!isUploading && uploadErrors.length === 0">
           <mat-icon class="check">check_circle</mat-icon>
           <span>{{ (selectedFile.size / 1024).toFixed(1) }} KB ready for processing</span>
         </ng-container>
       </div>
       <button class="remove-link" *ngIf="!isUploading" (click)="$event.stopPropagation(); removeFile(fileInput)">Remove</button>
    </div>

    <div class="upload-errors" *ngIf="uploadErrors.length > 0">
      <div class="errors-header">
        <mat-icon class="error-icon">error_outline</mat-icon>
        <span>{{ uploadErrors.length }} error{{ uploadErrors.length > 1 ? 's' : '' }} found — please fix and re-upload</span>
      </div>
      <ul class="errors-list">
        <li *ngFor="let err of uploadErrors">{{ err }}</li>
      </ul>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn-cancel" (click)="onCancel()">Cancel</button>
    <div class="footer-actions">
      <button class="btn-confirm" [disabled]="!selectedFile || isUploading" (click)="uploadFile()">
        <mat-icon *ngIf="!isUploading">done</mat-icon>
        <span>{{ isUploading ? 'Uploading...' : 'Confirm Upload' }}</span>
      </button>
    </div>
  </div>
</div>